import { render, staticRenderFns } from "./Ro_Services.vue?vue&type=template&id=242b425e&scoped=true"
import script from "./Ro_Services.vue?vue&type=script&lang=js"
export * from "./Ro_Services.vue?vue&type=script&lang=js"
import style0 from "./Ro_Services.vue?vue&type=style&index=0&id=242b425e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242b425e",
  null
  
)

export default component.exports